module.exports = __webpack_public_path__ + "static/media/edit-btn.869e446d.svg";